import { PhoneNumberWithPrefix } from "@modules/box/boxTypes"
import { BoxLeadEntity } from "@modules/boxLead/entities/boxLeadEntity"
import { ExperienceLevel, Goals, HeardAboutUs, LeadType } from "@modules/boxLead/entities/boxLeadTypes"
import { BoxLeadInputDto, BoxLeadInputDtoSchema } from "@modules/boxLead/gateway/boxLeadInputDto"

export class BoxLeadDraftEntity {
  userId?: string | null
  experienceLevel?: ExperienceLevel | null
  goals?: Goals[] | null
  hearAboutUs?: HeardAboutUs | null
  hearAboutUsSpecify?: string | null
  bestTimeToContact?: string | null
  madeByStaffId?: string | null
  firstname?: string | null
  lastname?: string | null
  email?: string | null
  phoneNumber?: PhoneNumberWithPrefix | null
  phoneNumberCountryCode?: string | null
  phoneNumberInput?: string | null
  note?: string | null
  firstContact: Date
  leadType: LeadType

  private constructor(draft: BoxLeadDraftEntity) {
    this.userId = draft.userId
    this.experienceLevel = draft.experienceLevel
    this.goals = draft.goals
    this.hearAboutUs = draft.hearAboutUs
    this.hearAboutUsSpecify = draft.hearAboutUsSpecify
    this.bestTimeToContact = draft.bestTimeToContact
    this.madeByStaffId = draft.madeByStaffId
    this.firstname = draft.firstname
    this.lastname = draft.lastname
    this.email = draft.email
    this.phoneNumber = draft.phoneNumber
    this.phoneNumberCountryCode = draft.phoneNumberCountryCode
    this.phoneNumberInput = draft.phoneNumberInput
    this.note = draft.note
    this.firstContact = draft.firstContact
    this.leadType = draft.leadType
  }

  static createDraft(boxLead?: BoxLeadEntity): BoxLeadDraftEntity {
    return new BoxLeadDraftEntity({
      userId: boxLead?.user?.id ?? undefined,
      experienceLevel: boxLead?.experienceLevel ?? undefined,
      goals: boxLead?.goals ?? undefined,
      hearAboutUs: boxLead?.hearAboutUs ?? undefined,
      hearAboutUsSpecify: boxLead?.hearAboutUsSpecify ?? undefined,
      bestTimeToContact: boxLead?.bestTimeToContact ?? undefined,
      madeByStaffId: boxLead?.madeByStaff?.staffMemberId ?? undefined,
      firstname: boxLead?.firstname && !boxLead.user?.id ? boxLead.firstname : undefined,
      lastname: boxLead?.lastname && !boxLead.user?.id ? boxLead.lastname : undefined,
      email: boxLead?.email ?? undefined,
      phoneNumber: boxLead?.phoneNumber ?? undefined,
      phoneNumberCountryCode: boxLead?.phoneNumber?.countryCode ?? undefined,
      phoneNumberInput: boxLead?.phoneNumber?.number ?? undefined,
      note: boxLead?.note ?? undefined,
      firstContact: boxLead?.firstContact ?? new Date(),
      leadType: boxLead?.leadType ?? LeadType.MANUAL_ADDITION,
    })
  }

  static toDto(draft: BoxLeadDraftEntity): BoxLeadInputDto {
    return BoxLeadInputDtoSchema.parse({
      userId: draft.userId === "" ? null : draft.userId,
      experienceLevel: draft.experienceLevel,
      goals: draft.goals,
      hearAboutUs: draft.hearAboutUs,
      hearAboutUsSpecify: draft.hearAboutUsSpecify,
      bestTimeToContact: draft.bestTimeToContact,
      madeByStaffId: draft.madeByStaffId,
      firstname: draft.firstname === "" ? null : draft.firstname,
      lastname: draft.lastname === "" ? null : draft.lastname,
      email: draft.email === "" ? null : draft.email,
      phoneNumber:
        draft.phoneNumberInput && draft.phoneNumberCountryCode
          ? {
              countryCode: draft.phoneNumberCountryCode,
              number: draft.phoneNumberInput,
            }
          : null,
      note: draft.note,
      firstContact: draft.firstContact.toISOString(),
      leadType: draft.leadType,
    })
  }
}
